export default "__VITE_ASSET__BEPsdmYg__"